import { SortAlphabeticalVariantIcon } from './SortAlphabeticalVariantIcon';

/**
 * author: Google
 * id C2687EF2-6AEB-48BC-98E5-9A010C6E2BE7
 * name sort-alphabetical-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sort-alphabetical-variant.svg
 * tags
 * - Text / Content / Format 
 */
export const SortAlphabeticallyIcon = SortAlphabeticalVariantIcon;
export default SortAlphabeticallyIcon